export default class PieChart {
  constructor(controller) {
    this.dataset = controller.datasetValue
    this.withLegend = controller.withLegendValue && controller.hasLegendTarget
    this.legendContainer = controller.legendTarget
    this.chart = controller.chart
  }

  setChart() {
    const source = this.dataset.length > 5
      ? this.dataset.reduce((acc, item, index) => {
          if (index < 5) {
            acc.push(item)
          } else if (index === 5) {
            acc.push(['Others', item[1]])
          } else {
            acc[5][1] += item[1]
          }
          return acc
        }, [])
      : this.dataset

    const othersDataSet = this.dataset.length > 5 ? this.dataset.slice(5) : []

    const dataset = {
      dimensions: ['name', 'value'],
      source
    }

    const colorPalette = ['#FF5800', '#0A2540', '#F32E5E', '#5460EA', '#FFB74E', '#80868C']
    const totalValue = dataset.source.reduce((sum, item) => sum + item[1], 0)

    if (this.withLegend) {
      const legendContent = dataset.source.map(item => {
        const percentage = ((item[1] / totalValue) * 100).toFixed(1)
        const itemIndex = dataset.source.indexOf(item)
        const color = colorPalette[itemIndex]
        return `
          <div class="flex justify-between items-center gap-16 w-full">
            <div class="flex items-center gap-8">
              <div class="min-w-6 min-h-6 size-6 rounded-full" style="background: ${color};"></div>
              <span class="font-work-sans text-sm">${item[0]}</span>
            </div>
            <span class="font-work-sans text-sm font-medium" style="color: ${color};">${percentage}%</span>
          </div>
        `
      }).join('')

      this.legendContainer.innerHTML = legendContent
    }

    const option = {
      color: colorPalette,
      dataset,
      tooltip: {
        trigger: 'item',
        enterable: true,
        confine: true,
        appendToBody: true,
        borderWidth: 0,
        formatter: (params) => {
          const index = params.dataIndex
          const displayPercent = Number.isInteger(params.percent)
            ? params.percent
            : params.percent.toFixed(1)
          return index < 5
            ? `
              <span class="font-work-sans text-sm">${params.name}</span>
              <span class="font-work-sans text-lg font-semibold" style="color: ${colorPalette[index]};">${displayPercent}%</span>
            `
            : `
              <div class="chart-pie-tooltip">
                <div>
                  <span class="font-work-sans text-sm">${params.name}</span>
                  <span class="font-work-sans text-lg font-semibold" style="color: ${colorPalette[index]};">${displayPercent}%</span>
                </div>
                <div class="flex flex-col gap-4 w-160 mt-8 overflow-hidden">
                  ${othersDataSet.map(item => `
                    <div class="flex justify-between items-center gap-8">
                      <span class="font-work-sans text-seasalt-500 text-sm leading-18 whitespace-normal">${item[0]}</span>
                      <span class="font-work-sans text-seasalt-500 text-sm font-medium leading-18">${((item[1] / totalValue) * 100).toFixed(1)}%</span>
                    </div>
                  `).join('')}
                </div>
              </div>
            `
        }
      },
      series: [
        {
          type: 'pie',
          radius: ['50%', '100%'],
          avoidLabelOverlap: false,
          startAngle: 70,
          padAngle: 5,
          itemStyle: {
            borderRadius: 5
          },
          label: {
            show: false,
            position: 'center'
          },
          labelLine: {
            show: false
          },
          emphasis: {
            scale: false
          },
        }
      ]
    }

    this.chart.setOption(option)
  }
}
